/* eslint-disable @next/next/no-img-element */
import useCommon from '@utils/hooks/common';
import styles from './styles';
import classNames from 'classnames';
import {Row, Col} from 'antd';

interface Props {
  isManualDeposit: boolean;
  toggleSwitch: () => void;
}

const DepositMethodSwitch = (props: Props) => {
  const {classes, t, user} = useCommon({
    withTranslation: ['deposit_withdraw'],
    withStyles: styles,
    observers: ['user'],
  });

  const {isManualDeposit, toggleSwitch} = props;

  return (
    <div
      className={classNames(classes.switch, {[classes.switchOn]: isManualDeposit})}
      onClick={toggleSwitch}
    >
      <Row style={{display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%'}}>
        <Col span={12} className={classes.switchLabel}>
          {t('common:wallet_connect')}
        </Col>
        <Col span={12} className={classes.switchLabel}>
          {t('manual_deposit')}
        </Col>
      </Row>
      <div
        className={classNames(classes.switchHandle, {
          [classes.switchHandleOn]: isManualDeposit,
        })}
      >
        {isManualDeposit ? (
          <div className={classes.buttonLabel}>{t('manual_deposit')}</div>
        ) : (
          <div className={classes.buttonLabel}>{t('common:wallet_connect')}</div>
        )}
      </div>
    </div>
  );
};

export default DepositMethodSwitch;
